// Format date helper
export const formatDate = (dateString) => {
  if (!dateString) return '';
  // Create date object directly from YYYY-MM-DD string
  // By adding T12:00:00 we ensure it's noon UTC and won't shift days
  const date = new Date(`${dateString}T12:00:00`);
  if (isNaN(date.getTime())) return ''; // Invalid date
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC'  // Force UTC timezone to prevent any shifts
  });
};

// Get safe value helper
export const getSafeValue = (value) => (value === null || value === undefined ? "" : value);

// Normalize quarter helper
export const normalizeQuarter = (quarter) => {
  // Remove 'Q' if present and convert to string
  return quarter.toString().replace('Q', '');
};

// Get cell coordinates from DOM element
export const getCellCoords = (element) => {
  const row = element.closest('tr').rowIndex - 2; // Adjusted to account for two header rows
  const col = element.cellIndex - 1;
  return [row, col];
};

// Update spreadsheet cells API call
export const updateSpreadsheetCells = async (database, spreadsheetName, year, cellsData) => {
  const url = `https://plansync-backend-234288438538.us-central1.run.app/api/update_spreadsheet_cells/${database}/${spreadsheetName}/${year}`;
  
  console.log('Sending request to:', url);
  console.log('Request payload:', cellsData);
  
  try {
    const response = await fetch(
      url,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cellsData),
      }
    );
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Server response:', errorText);
      throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log('Server response:', data);
    return data;
  } catch (error) {
    console.error('Error updating cells:', error);
    throw error;
  }
};

// Auto resize textarea helper
export const autoResizeTextarea = (element) => {
  element.style.height = 'auto';
  element.style.height = `${element.scrollHeight}px`;
};